/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiUTMEntityStatus;
(function (ApiUTMEntityStatus) {
    ApiUTMEntityStatus["UTM_ENTITY_STATUS_UNSPECIFIED"] = "UTMEntityStatusUnspecified";
    ApiUTMEntityStatus["UTM_ENTITY_STATUS_COMPATIBLE"] = "UTMEntityStatusCompatible";
    ApiUTMEntityStatus["UTM_ENTITY_STATUS_MAPPING"] = "UTMEntityStatusMapping";
    ApiUTMEntityStatus["UTM_ENTITY_STATUS_INCOMPATIBLE"] = "UTMEntityStatusIncompatible";
    ApiUTMEntityStatus["UTM_ENTITY_STATUS_INACTIVE"] = "UTMEntityStatusInactive";
})(ApiUTMEntityStatus || (ApiUTMEntityStatus = {}));
export function ApiUTMEntityStatusFromJSON(json) {
    return ApiUTMEntityStatusFromJSONTyped(json, false);
}
export function ApiUTMEntityStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiUTMEntityStatusToJSON(value) {
    return value;
}
